import { cn } from "@/lib/utils";

type RequiredIndicatorProps = {
  className?: string;
};

/** Blue asterisk for required form labels — matches standout button color (`blue-100`). */
export const RequiredIndicator: React.FC<RequiredIndicatorProps> = ({ className }) => (
  <span className={cn("text-blue-100", className)} aria-hidden="true">
    *
  </span>
);
